
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class PsAdvPromoItemGrid extends Serenity.EntityGrid<PsAdvPromoItemRow, any> {
        protected getColumnsKey() { return PsAdvPromoItemColumns.columnsKey; }
        protected getDialogType() { return PsAdvPromoItemDialog; }
        protected getIdProperty() { return PsAdvPromoItemRow.idProperty; }
        protected getInsertPermission() { return PsAdvPromoItemRow.insertPermission; }
        protected getLocalTextPrefix() { return PsAdvPromoItemRow.localTextPrefix; }
        protected getService() { return PsAdvPromoItemService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}